import { CarriersFilter } from "./useCarriersFilter";

type CarriersFilterKey<TValue> = {
  [Key in keyof CarriersFilter]-?: CarriersFilter[Key] extends TValue
    ? Key
    : never;
}[keyof CarriersFilter];

const appendFlag = (
  params: URLSearchParams,
  carriersFilter: CarriersFilter,
  key: CarriersFilterKey<boolean>
) => {
  if (carriersFilter[key]) {
    params.append(key, "true");
  }
};

const appendText = (
  params: URLSearchParams,
  carriersFilter: CarriersFilter,
  key: CarriersFilterKey<string>
) => {
  const text: string = carriersFilter[key];

  if (text) {
    params.append(key, text);
  }
};

const appendList = (
  params: URLSearchParams,
  carriersFilter: CarriersFilter,
  key: CarriersFilterKey<(string | number)[]>
) => {
  const values: (string | number)[] = carriersFilter[key];

  values.forEach((value) => params.append(key, value.toString()));
};

export const appendCarrierFilterParams = (
  params: URLSearchParams,
  carriersFilter: CarriersFilter
) => {
  if (carriersFilter.search) {
    params.append("search", carriersFilter.search.trim());
  }

  appendFlag(params, carriersFilter, "myCarriers");
  appendFlag(params, carriersFilter, "myFavoriteCarriers");
  appendFlag(params, carriersFilter, "unownedCarriers");
  appendText(params, carriersFilter, "capacityPickupDate");
  appendText(params, carriersFilter, "capacityOrigin");
  appendText(params, carriersFilter, "capacityDestination");

  carriersFilter.accountOwners.forEach((accountOwner) =>
    params.append("accountOwners", accountOwner.key)
  );

  appendList(params, carriersFilter, "statuses");
  appendList(params, carriersFilter, "trailerBuildTypeIds");
  appendFlag(params, carriersFilter, "hasEvTrucks");
  appendFlag(params, carriersFilter, "hasHvoTrucks");
  appendFlag(params, carriersFilter, "hasGpsTrackTrace");

  if (carriersFilter.shippeoOnboardedStatus) {
    params.append("shippeoOnboarded", carriersFilter.shippeoOnboardedStatus);
  }

  appendFlag(params, carriersFilter, "lf4ForMercedes");
  appendFlag(params, carriersFilter, "vdiCertification");
  appendFlag(params, carriersFilter, "daimlerRulesCompliance");
  appendFlag(params, carriersFilter, "toyotaRulesCompliance");
  appendList(params, carriersFilter, "preferredLaneOriginCountryCodes");
  appendList(params, carriersFilter, "preferredLaneDestinationCountryCodes");
  appendList(params, carriersFilter, "carrierCountries");
  appendText(params, carriersFilter, "minInsuranceAmount");
  appendText(params, carriersFilter, "insuranceStatus");
  appendText(params, carriersFilter, "transportLicenseStatus");
  appendText(params, carriersFilter, "lastDeliveredFrom");
  appendText(params, carriersFilter, "lastDeliveredTo");
  appendFlag(params, carriersFilter, "notActiveMoreThanSixMonths");
  appendList(params, carriersFilter, "shipmentOriginCountryCodes");
  appendList(params, carriersFilter, "shipmentOriginCities");
  appendList(params, carriersFilter, "shipmentDestinationCountryCodes");
  appendList(params, carriersFilter, "shipmentDestinationCities");
  appendText(params, carriersFilter, "shipmentRouteCompletedDateFrom");
  appendText(params, carriersFilter, "shipmentRouteCompletedDateTo");

  return params;
};
